import { useUserProfileContext } from "@context/user_profile";
import { Navigate, Outlet } from "react-router";

export default function DashboardRoute() {
    const [isLoadingUserProfile, userInfo] = useUserProfileContext();
    if (isLoadingUserProfile) return <></>;

    // redirect to login page
    if (!userInfo) return <Navigate to="/" />

    return <Outlet />
}